"use client";
import React from "react";

const ItemGoalLoss = ({ratios, time}) => {
  return (
    <div className="w-full flex flex-col gap-1">
      <div className="w-full flex justify-between gap-1">
        <div className="">{Math.round(Number(ratios.homeRatios)) || 0} %</div>
        <div className="">{Math.round(Number(ratios.awayRatios)) || 0} %</div>
      </div>
      <div className="bg-white dark:bg-league-gray-dark h-[10px] rounded-[20px] relative grid grid-cols-2 gap-[35px] md:gap-[67px]">
        <div className="value_ItemGoalLoss text-[8px] md:text-[12px] m-auto flex justify-center items-center w-[35px] md:w-[67px] h-[22px] absolute left-0 right-0 top-0 bottom-0 rounded-[6px] bg-white dark:bg-black">
          {time}
        </div>
        <div className="h-full flex justify-end">
          <div
            className="h-full bg-button-blue-bet dark:bg-large-blue rounded-tl-[20px] rounded-bl-[20px]"
            style={{ width: `${Math.round(Number.parseFloat(ratios.homeRatios))}%` }}
          ></div>
        </div>
        <div className="h-full">
          <div
            className="h-full bg-gradient-start rounded-tr-[20px] rounded-br-[20px]"
            style={{ width: `${Math.round(Number.parseFloat(ratios.awayRatios))}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default ItemGoalLoss;
